module.exports = __webpack_public_path__ + "Frame404-12c4ddb0.webp";